import { render, staticRenderFns } from "./courseinformation.vue?vue&type=template&id=65e5958d&scoped=true&"
import script from "./courseinformation.vue?vue&type=script&lang=js&"
export * from "./courseinformation.vue?vue&type=script&lang=js&"
import style0 from "./courseinformation.vue?vue&type=style&index=0&id=65e5958d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5958d",
  null
  
)

export default component.exports